import { collectNumbers, numericExtent, fractalsSeries } from "../utils";
const Fractals = {
    name: "Fractals",
    compute: (bars) => fractalsSeries(bars),
    computeExtents: (values) => numericExtent(collectNumbers(values)),
    render: () => undefined,
};
export default Fractals;
